export const formatCustomerData = (allData: any[] = []) => {
  return allData.map(item => {
    const addr = item.address || {};

    return {
      ...item,
      address: [
        addr.address,
        addr.city,
        addr.region,
        addr.zip,
      ]
        .filter(Boolean)
        .join(', ')
    };
  });
};